import {
  Anchor, ArrowUpRight, Brain, CheckSquare, FolderKanban, Lightbulb, Map as MapIcon, MessageCircle, PlayCircle, Sparkles, Sprout,
  type LucideIcon,
} from "lucide-react";
import type { NowLinkKind, NowMode } from "../api/now";
import type { WorkspaceItemSection } from "./workspaceHandoff";

export const NOW_MODES: NowMode[] = ["everyday", "advance", "respond", "steady", "grow"];

export const NOW_MODE_ICON: Record<NowMode, LucideIcon> = {
  everyday: Sparkles,
  advance: ArrowUpRight,
  respond: MessageCircle,
  steady: Anchor,
  grow: Sprout,
};

export const NOW_LINK_ICON: Record<NowLinkKind, LucideIcon> = {
  project: FolderKanban,
  journey: MapIcon,
  trait: Sprout,
  mental_model: Brain,
  activity: PlayCircle,
  insight: Lightbulb,
  action: CheckSquare,
};

export interface FollowUpTarget {
  path: string;
  mmId?: string;
  workspace?: { section: WorkspaceItemSection; id: string };
}

/** Where a follow-up link goes. The caller stages mmId / workspace before navigating. */
export function followUpTarget(kind: NowLinkKind, id: string): FollowUpTarget {
  switch (kind) {
    case "project":
    case "journey":
      return { path: `/project/${id}` };
    case "activity":
      return { path: `/activities/run?wid=${id}` };
    case "mental_model":
      return { path: "/portal", mmId: id };
    case "action":
      return { path: "/portal", workspace: { section: "action_items", id } };
    case "insight":
      return { path: "/portal", workspace: { section: "insights", id } };
    case "trait":
      return { path: "/portal" }; // no place to land; the server no longer sends trait links
  }
}
